
import { createContext, useContext, useState } from "react"

const ServiceContext = createContext()

export const ServiceProvider = ({ children }) => {
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [selectedService, setSelectedService] = useState(null)
  const [selectedServices, setSelectedServices] = useState([])
  const [quantity, setQuantity] = useState(1)
  const [customerInfo, setCustomerInfo] = useState({
    name: "",
    email: "",
    phone: "",
  })
  const [otheFormFields, setOtherFormFields] = useState({})

  return (
    <ServiceContext.Provider
      value={{
        selectedCategory,
        setSelectedCategory,
        selectedService,
        setSelectedService,
        selectedServices,
        setSelectedServices,
        quantity,
        setQuantity,
        customerInfo,
        setCustomerInfo,
        setOtherFormFields,
        otheFormFields
      }}
    >
      {children}
    </ServiceContext.Provider>
  )
}

export const useServiceContext = () => {
  const context = useContext(ServiceContext)
  if (!context) {
    throw new Error("useServiceContext must be used within a ServiceProvider")
  }
  return context
}
